module.exports = __webpack_public_path__ + "img/北京大学logo.db5ea24d.png";